module.exports = __webpack_public_path__ + "menu_1_active_pc.d6bfff2d.png";